import { FC } from 'react';
import type { VirtualItem } from '@tanstack/react-virtual';
import type { DataTableColumn, DataTableDimensions } from '@/components/UI/DataTableV2/DataTable.model';
import { DataTableColumnHeader } from './DataTableColumnHeader';
import { useDataTable } from '../DataTableProvider';

interface ScrollableColumnHeadersProps {
  virtualColumns: Array<VirtualItem>;
  scrollableColumns: Array<DataTableColumn>;
  stickyColumnCount: number;
  groupHeaderHeight: number;
  dimensions: DataTableDimensions;
}

export const ScrollableColumnHeaders: FC<ScrollableColumnHeadersProps> = ({
  virtualColumns,
  scrollableColumns,
  stickyColumnCount,
  groupHeaderHeight,
  dimensions,
}) => {
  const { dataTableService } = useDataTable();

  return (
    <>
      {virtualColumns.map((virtualColumn) => {
        const column = scrollableColumns[virtualColumn.index];
        const columnIndex = dataTableService.toIndexColumn(column.id);

        if (columnIndex === undefined) {
          return null;
        }

        return (
          <DataTableColumnHeader
            key={column.id}
            columnIndex={columnIndex}
            positionOffset={{
              x: virtualColumn.start,
              y: groupHeaderHeight,
            }}
          />
        );
      })}
    </>
  );
};
